import { useState } from 'react';

const Feedbackform = () => {

    const [formData, setFormData] = useState({ name: '', mobile: '', email: '', district: '', clubName: '', rating: 0, review: '', suggestion: '' });

    const [hoverRating, setHoverRating] = useState(0);

    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (formData.rating === 0) {
            alert('Please select a star rating.');
            return;
        }
        try {
            const response = await fetch('https://lcoiapi.emedha.in/appi/feedback',
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(formData)
                }
            );

            const result = await response.json();

            if (!response.ok) {
                throw new Error(result.message || 'Failed to submit feedback');
            }

            alert(result.message);

            setFormData({
                name: '',
                mobile: '',
                email: '',
                district: '',
                clubName: '',
                rating: 0,
                review: '',
                suggestion: ''
            });
        } catch (error) {
            console.error('Submission error:', error);
            alert(error.message || 'Unable to submit feedback. Please try again.');
        }
    };

    return (
        <div style={{ minHeight: '100vh', padding: '30px 15px', backgroundColor: '#f4f6fa', fontFamily: 'Arial, sans-serif', boxSizing: 'border-box' }}>
            <div style={{ width: '100%', maxWidth: '720px', margin: '0 auto', backgroundColor: '#fff', borderRadius: '12px', overflow: 'hidden', boxShadow: '0 5px 20px rgba(0,0,0,0.08)' }}>
                {/* Form Header */}
                <div style={{ backgroundColor: '#123b75', color: '#fff', padding: '25px 20px', textAlign: 'center' }}>
                    <h2 style={{ margin: '0 0 8px', fontSize: '24px' }}>Lions Digital Magazine</h2>
                    <h3 style={{ margin: '0 0 10px', fontSize: '18px' }}>Rating &amp; Review Form</h3>
                    <p style={{ margin: 0, fontSize: '14px', color: '#e1e9f5' }}>Share your feedback and help us improve.</p>
                </div>

                {/* Form Body */}
                <form onSubmit={handleSubmit} style={{ padding: '25px' }}>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 260px), 1fr))', gap: '20px' }}>
                        {/* Name */}
                        <div style={{ display: 'flex', flexDirection: 'column', minWidth: 0 }}>
                            <label htmlFor="name" style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '600', color: '#283548' }}>Name *</label>
                            <input id="name" type="text" name="name" placeholder="Enter your full name" value={formData.name} onChange={handleChange} style={{ width: '100%', padding: '12px', border: '1px solid #d5dbe5', borderRadius: '6px', fontSize: '14px', boxSizing: 'border-box', outline: 'none' }} required />
                        </div>

                        {/* Mobile */}
                        <div style={{ display: 'flex', flexDirection: 'column', minWidth: 0 }}>
                            <label htmlFor="mobile" style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '600', color: '#283548' }}>Mobile *</label>
                            <input id="mobile" type="tel" name="mobile" placeholder="Enter 10-digit mobile number" value={formData.mobile} onChange={handleChange} style={{ width: '100%', padding: '12px', border: '1px solid #d5dbe5', borderRadius: '6px', fontSize: '14px', boxSizing: 'border-box', outline: 'none' }} pattern="[0-9]{10}" maxLength={10} title="Enter a valid 10-digit mobile number" required />
                        </div>

                        {/* Email */}
                        <div style={{ display: 'flex', flexDirection: 'column', minWidth: 0 }}>
                            <label htmlFor="email" style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '600', color: '#283548' }}>Email *</label>
                            <input id="email" type="email" name="email" placeholder="Enter email address" value={formData.email} onChange={handleChange} style={{ width: '100%', padding: '12px', border: '1px solid #d5dbe5', borderRadius: '6px', fontSize: '14px', boxSizing: 'border-box', outline: 'none' }} required />
                        </div>

                        {/* District */}
                        <div style={{ display: 'flex', flexDirection: 'column', minWidth: 0 }}>
                            <label htmlFor="district" style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '600', color: '#283548' }}>District *</label>
                            <input id="district" type="text" name="district" placeholder="Enter district" value={formData.district} onChange={handleChange} style={{ width: '100%', padding: '12px', border: '1px solid #d5dbe5', borderRadius: '6px', fontSize: '14px', boxSizing: 'border-box', outline: 'none' }} required />
                        </div>

                        {/* Club Name */}
                        <div style={{ display: 'flex', flexDirection: 'column', minWidth: 0, gridColumn: '1 / -1' }}>
                            <label htmlFor="clubName" style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '600', color: '#283548' }}>Club Name *</label>
                            <input id="clubName" type="text" name="clubName" placeholder="Enter your Lions Club name" value={formData.clubName} onChange={handleChange} style={{ width: '100%', padding: '12px', border: '1px solid #d5dbe5', borderRadius: '6px', fontSize: '14px', boxSizing: 'border-box', outline: 'none' }} required />
                        </div>

                        {/* Star Rating */}
                        <div style={{ display: 'flex', flexDirection: 'column', minWidth: 0, gridColumn: '1 / -1' }}>
                            <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '600', color: '#283548' }}>Rate the Digital Magazine *</label>
                            <div role="radiogroup" aria-label="Magazine rating" style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '5px' }}>
                                {[1, 2, 3, 4, 5].map((star) => (
                                    <button
                                        key={star}
                                        type="button"
                                        role="radio"
                                        aria-checked={formData.rating === star}
                                        aria-label={`${star} star${star > 1 ? 's' : ''}`}
                                        onClick={() =>
                                            setFormData((prev) => ({
                                                ...prev,
                                                rating: star
                                            }))
                                        }
                                        onMouseEnter={() => setHoverRating(star)}
                                        onMouseLeave={() => setHoverRating(0)}
                                        onFocus={() => setHoverRating(star)}
                                        onBlur={() => setHoverRating(0)}
                                        style={{
                                            border: 'none',
                                            background: 'transparent',
                                            cursor: 'pointer',
                                            fontSize: '34px',
                                            padding: '0 2px',
                                            lineHeight: 1,
                                            color:
                                                star <= (hoverRating || formData.rating)
                                                    ? '#f5ad24'
                                                    : '#d0d5dd'
                                        }}
                                    >
                                        ★
                                    </button>
                                ))}

                                <span style={{ marginLeft: '8px', color: '#687386', fontSize: '13px' }}>
                                    {formData.rating
                                        ? `${formData.rating} / 5`
                                        : 'Select rating'}
                                </span>
                            </div>
                        </div>

                        {/* Review */}
                        <div style={{ display: 'flex', flexDirection: 'column', minWidth: 0, gridColumn: '1 / -1' }}>
                            <label htmlFor="review" style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '600', color: '#283548' }}>Review *</label>
                            <textarea id="review" name="review" placeholder="Share your experience with the magazine..." rows={4} value={formData.review} onChange={handleChange} style={{ width: '100%', padding: '12px', border: '1px solid #d5dbe5', borderRadius: '6px', fontSize: '14px', boxSizing: 'border-box', outline: 'none', resize: 'vertical', fontFamily: 'inherit' }} required />
                        </div>

                        {/* Suggestions */}
                        <div style={{ display: 'flex', flexDirection: 'column', minWidth: 0, gridColumn: '1 / -1' }}>
                            <label htmlFor="suggestion" style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '600', color: '#283548' }}>Any Suggestions?</label>
                            <textarea id="suggestion" name="suggestion" placeholder="Share your ideas or suggestions (optional)" rows={3} value={formData.suggestion} onChange={handleChange} style={{ width: '100%', padding: '12px', border: '1px solid #d5dbe5', borderRadius: '6px', fontSize: '14px', boxSizing: 'border-box', outline: 'none', resize: 'vertical', fontFamily: 'inherit' }} />
                        </div>
                    </div>

                    {/* Submit Button */}
                    <button type="submit" style={{ width: '100%', padding: '14px', marginTop: '25px', backgroundColor: '#123b75', color: '#fff', border: 'none', borderRadius: '6px', fontSize: '16px', fontWeight: '600', cursor: 'pointer' }}>Submit Feedback</button>
                </form>
            </div>
        </div>
    );


};

export default Feedbackform;